import classNames from 'classnames';
import React, {forwardRef} from 'react';
import {Controller} from 'react-hook-form';
import {debounce} from '../../utils';

const InputField = forwardRef(function _InputField(props, ref) {
  const {error, className, fullWidth = false, ...restProps} = props;
  return (
    <div className={classNames('flex flex-col', fullWidth ? 'w-full' : '')}>
      <input
        ref={ref}
        className={classNames(
          'py-3 px-4 border rounded-sm',
          error ? 'border-error' : 'border-gray-400',
          fullWidth && 'w-full',
          className,
        )}
        {...restProps}
      />
      {error && <div className="text-error text-sm pt-1">{error}</div>}
    </div>
  );
});

export const DebounceInput = ({control, name, ...restProps}) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({field}) => (
        <InputField
          {...restProps}
          onChange={debounce((e) => field.onChange(e), 500)}
          defaultValue={field.value}
        />
      )}
    />
  );
};

export default InputField;
